"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageNameByFullTag = exports.getLanguageTagByFullTag = exports.getLanguageNameByTag = exports.getAllDialectTags = exports.getAllLanguages = exports.getAllLanguageTags = void 0;
const dialectCodes_json_1 = __importDefault(require("./data/dialectCodes.json"));
const languageCodes_json_1 = __importDefault(require("./data/languageCodes.json"));
const languageNameByTag_json_1 = __importDefault(require("./data/languageNameByTag.json"));
/**
 *
 * @returns an array of all available language tags (es. en, es, etc.)
 */
const getAllLanguageTags = () => {
    return languageCodes_json_1.default.sort((a, b) => a.localeCompare(b));
};
exports.getAllLanguageTags = getAllLanguageTags;
/**
 *
 * @returns an array of all available languages names (es. English, Spanish, etc.)
 */
const getAllLanguages = () => {
    return Object.values(languageNameByTag_json_1.default).sort((a, b) => a.localeCompare(b));
};
exports.getAllLanguages = getAllLanguages;
/**
 *
 * @returns an array of all available dialects tags (es. en-US, en-GB, etc.)
 */
const getAllDialectTags = () => {
    return dialectCodes_json_1.default;
};
exports.getAllDialectTags = getAllDialectTags;
/**
 *
 * @param tag the language tag (es. en, es, etc.)
 * @returns the language name
 */
const getLanguageNameByTag = (tag) => {
    var _a;
    return (_a = languageNameByTag_json_1.default[tag]) !== null && _a !== void 0 ? _a : null;
};
exports.getLanguageNameByTag = getLanguageNameByTag;
/**
 *
 * @param fullTag the language tag in any format (es. en, es, en-US, jp-HK, etc.)
 * @returns the language tag in the correct format (es. en, es, etc.)
 */
const getLanguageTagByFullTag = (fullTag) => {
    let tag = fullTag;
    if (!isLanguageTagValid(tag)) {
        tag = fullTag.split("-")[0];
        if (!isLanguageTagValid(tag)) {
            return null;
        }
    }
    return tag;
    function isLanguageTagValid(tag) {
        return (0, exports.getAllLanguageTags)().includes(tag);
    }
};
exports.getLanguageTagByFullTag = getLanguageTagByFullTag;
/**
 *
 * @param fullTag the language tag in any format (es. en, es, en-US, jp-HK, etc.)
 * @returns the language name (es. English, Spanish, etc.)
 */
const getLanguageNameByFullTag = (fullTag) => {
    const tag = (0, exports.getLanguageTagByFullTag)(fullTag);
    if (tag === null)
        return null;
    return (0, exports.getLanguageNameByTag)(tag);
};
exports.getLanguageNameByFullTag = getLanguageNameByFullTag;
